import type { FC, ReactNode } from 'react'

import { BookmarkCheck, BookmarkPlus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useFavorites, useToast } from '@/components/generals/providers'
import { Button } from '@/components/ds/button'

interface FavoriteButtonProps {
    slug: string
    compact?: boolean
    className?: string
}

export const FavoriteButton: FC<FavoriteButtonProps> = ({ slug, compact = false, className }): ReactNode => {
    const { isFavorite, toggleFavorite, ready } = useFavorites()
    const { notify } = useToast()
    const saved = ready && isFavorite(slug)
    const Icon = saved ? BookmarkCheck : BookmarkPlus
    const label = saved ? 'حذف از علاقه‌مندی‌ها' : 'افزودن به علاقه‌مندی‌ها'

    return (
        <Button
            variant={saved ? 'secondary' : 'outline'}
            size={compact ? 'icon-sm' : 'md'}
            aria-pressed={saved}
            aria-label={compact ? label : undefined}
            title={compact ? label : undefined}
            onClick={() => {
                const added = toggleFavorite(slug)

                notify(added ? 'به علاقه‌مندی‌ها اضافه شد' : 'از علاقه‌مندی‌ها حذف شد', added ? 'success' : 'info')
            }}
            className={cn('relative z-10', className)}
        >
            <Icon className={cn(saved && 'text-primary-strong')} aria-hidden='true' />
            {!compact && (saved ? 'در علاقه‌مندی‌ها' : 'افزودن به علاقه‌مندی‌ها')}
        </Button>
    )
}
